import React from 'react';
import { Checkbox as MCheckbox, FormControlLabel } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { styled } from '@mui/material/styles';

import { FORTA_BLACK, FORTA_BLUE, FORTA_WHITE } from '../../utils/colors';
import { Themes } from '../../constants';
import CheckIcon from '../svgs/CheckIcon';
import { getThemeColor } from '../../utils/common';

import type { CheckboxProps as MCheckboxProps } from '@mui/material';

interface CheckboxProps extends MCheckboxProps {
  label?: string | React.ReactNode;
  colorTheme?: Themes;
  coloredBackground?: boolean;
  iconSize?: {
    width: number;
    height: number;
  };
  iconStyles?: any;
}

interface IconProps {
  colorTheme?: Themes;
  coloredBackground?: boolean;
  sx?: any;
  size?: {
    width: number;
    height: number;
  };
}

const useStyles = makeStyles({
  root: {
    '&.MuiFormControlLabel-root': {
      marginLeft: 0,
      width: 'fit-content',
    },

    '& .MuiFormControlLabel-label.Mui-disabled': {
      color: `${FORTA_BLACK} !important`,
    },
  },
});

const Icon = styled('span', {
  shouldForwardProp: (prop) => prop !== 'colorTheme' && prop !== 'coloredBackground',
})<IconProps>(({ colorTheme, coloredBackground, size, sx }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: size?.width || 20,
  height: size?.height || 20,
  backgroundColor: coloredBackground ? getThemeColor(colorTheme).light3 : FORTA_WHITE,
  boxShadow: `0px 4px 4px ${getThemeColor(colorTheme).light2}`,
  borderRadius: 5,
  marginRight: '10px',
  ...sx,
}));

const FCheckbox = (props: CheckboxProps) => {
  const {
    label = '',
    colorTheme = Themes.Primary,
    coloredBackground = false,
    iconStyles = {},
    iconSize,
    sx,
    ...rest
  } = props;
  const classes = useStyles();

  return (
    <FormControlLabel
      className={classes.root}
      control={
        <MCheckbox
          {...rest}
          icon={
            <Icon
              colorTheme={colorTheme}
              coloredBackground={coloredBackground}
              size={iconSize}
              sx={{
                boxShadow: 'none',
                width: 24,
                height: 24,
                border: `1px solid ${FORTA_BLUE.light1}`,
                ...iconStyles,
              }}
            />
          }
          checkedIcon={
            <Icon
              colorTheme={colorTheme}
              coloredBackground={coloredBackground}
              sx={{
                textAlign: 'center',
                boxShadow: 'none',
                width: 24,
                height: 24,
                border: `1px solid ${FORTA_BLUE.primary}`,
                ...iconStyles,
              }}
              size={iconSize}
            >
              <CheckIcon color={getThemeColor(colorTheme).primary} />
            </Icon>
          }
          disableRipple
          sx={{
            padding: 0,
          }}
        />
      }
      label={label}
      sx={{ textAlign: 'left', ...sx }}
    />
  );
};

export default FCheckbox;
